import _isFinite from "lodash/isFinite";
import _round from "lodash/round";
import calculateAdjustedMonthlyPayment from './calculate-monthly-payment';
import calculateMaxLoan from './calculate-max-loan';
import calculateMonthlyBudget from './calculate-monthly-budget';
import calculateMortgageInsurance from './calculate-mortgage-insurance';
import getFundsNeeded from './get-funds-needed';
import getItemizedMonthlyPayments from './get-itemized-monthly-payments';
import getYearlyPropertyTax from './get-yearly-property-tax';
import validateLoanAmount from './validate-loan-amount';
import { getLoanProgramFromTerm, getLoanTermMonths } from './helpers';
import { DOWN_PAYMENT_PERCENT_INSURANCE } from '../data/constants';
export default function calculateScenario(shouldAddInsurance, _ref, _ref2) {
  var annualIncome = _ref.annualIncome,
      creditScore = _ref.creditScore,
      dti = _ref.dti,
      loanTerm = _ref.loanTerm,
      loanType = _ref.loanType,
      monthlyDebt = _ref.monthlyDebt,
      monthlyHoaDues = _ref.monthlyHoaDues,
      state = _ref.state,
      veteranType = _ref.veteranType,
      firstVaLoan = _ref.firstVaLoan,
      annualInterestRate = _ref.annualInterestRate,
      downPaymentOverride = _ref.downPayment,
      fundsNeeded = _ref.fundsNeeded,
      monthlyHomeownersInsurance = _ref.monthlyHomeownersInsurance,
      monthlyMortgageInsurance = _ref.monthlyMortgageInsurance,
      monthlyPropertyTax = _ref.monthlyPropertyTax;
  var outputSuggestedPurchasePrice = _ref2.suggestedPurchasePrice,
      outputDownPayment = _ref2.downPayment;
  var error = null;
  var loanProgram = getLoanProgramFromTerm(loanTerm);
  var loanTermMonths = getLoanTermMonths(loanTerm);
  var yearlyPropertyTax = getYearlyPropertyTax(monthlyPropertyTax, state, outputSuggestedPurchasePrice);
  var monthlyMortgagePayment = calculateAdjustedMonthlyPayment({
    annualIncome: annualIncome,
    dti: dti,
    monthlyDebt: monthlyDebt,
    monthlyHoaDues: monthlyHoaDues,
    monthlyHomeownersInsurance: monthlyHomeownersInsurance
  }, yearlyPropertyTax);
  var loanAmount = calculateMaxLoan({
    annualInterestRate: annualInterestRate,
    loanTermMonths: loanTermMonths,
    monthlyMortgagePayment: monthlyMortgagePayment
  });

  var _validateLoanAmount = validateLoanAmount({
    annualIncome: annualIncome,
    annualInterestRate: annualInterestRate,
    dti: dti,
    loanTermMonths: loanTermMonths,
    loanAmount: loanAmount,
    monthlyMortgagePayment: monthlyMortgagePayment,
    monthlyDebt: monthlyDebt
  });

  error = _validateLoanAmount.error;
  loanAmount = _validateLoanAmount.loanAmount;
  monthlyMortgagePayment = _validateLoanAmount.monthlyMortgagePayment;

  var _getFundsNeeded = getFundsNeeded({
    annualInterestRate: annualInterestRate,
    loanAmount: loanAmount,
    loanType: loanType,
    monthlyHomeownersInsurance: monthlyHomeownersInsurance,
    veteranType: veteranType,
    firstVaLoan: firstVaLoan,
    yearlyPropertyTax: yearlyPropertyTax,
    shouldAddInsurance: shouldAddInsurance,
    state: state,
    outputDownPayment: outputDownPayment,
    // overrides
    downPaymentOverride: downPaymentOverride,
    fundsNeeded: fundsNeeded
  }),
      downPayment = _getFundsNeeded.downPayment,
      closingCosts = _getFundsNeeded.closingCosts;

  var suggestedPurchasePrice = downPayment + loanAmount;

  var downPaymentPercent = _round(downPayment / suggestedPurchasePrice, 4);

  var isDownPaymentBelowMin = downPaymentPercent < DOWN_PAYMENT_PERCENT_INSURANCE;
  var mortgageInsurancePayment = _isFinite(monthlyMortgageInsurance) || shouldAddInsurance ? calculateMortgageInsurance({
    creditScore: creditScore,
    monthlyMortgageInsurance: monthlyMortgageInsurance,
    loanProgram: loanProgram,
    loanType: loanType,
    downPayment: downPayment,
    loanAmount: loanAmount
  }) : 0;
  var monthlyPayments = getItemizedMonthlyPayments({
    monthlyMortgagePayment: monthlyMortgagePayment,
    yearlyPropertyTax: yearlyPropertyTax,
    monthlyHomeownersInsurance: monthlyHomeownersInsurance,
    monthlyHoaDues: monthlyHoaDues,
    mortgageInsurancePayment: mortgageInsurancePayment
  });
  return {
    annualInterestRate: annualInterestRate,
    closingCosts: closingCosts,
    downPayment: Math.ceil(downPayment),
    // TODO don't round here, round up there
    downPaymentPercent: downPaymentPercent,
    dti: (monthlyPayments.total + monthlyDebt) / (annualIncome / 12),
    error: error,
    fundsNeeded: _round(downPayment + closingCosts.total, 2),
    // TODO don't round here, round up there
    isDownPaymentBelowMin: isDownPaymentBelowMin,
    loanAmount: loanAmount,
    loanProgram: loanProgram,
    loanTerm: loanTerm,
    loanType: loanType,
    monthlyBudget: calculateMonthlyBudget({
      annualIncome: annualIncome,
      monthlyDebt: monthlyDebt
    }, dti),
    suggestedPurchasePrice: Math.floor(suggestedPurchasePrice),
    // TODO don't round here, round up there
    monthlyPayments: monthlyPayments
  };
}